const { stemmer } = process.env.VUE_ENV === 'client' ? require('stemmer') : {};

export function roleToCurrentJobMatchScore(role, job) {
  const roleSkills = Array.isArray(role.skills) ? role.skills : [];
  const jobSkills = Array.isArray(job.skills) ? job.skills : [];
  let skills = jobSkills;
  if (!job.isDevelopment) {
    const userSkills = Array.isArray(parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills')))
      ? parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills'))
      : [];
    skills = skills.reduce((out, el) => {
      if (!userSkills.includes(el)) {
        out.push(el);
      }
      return out;
    }, []);
  }
  const matchedSkills = roleSkills.filter(el => skills.includes(el));
  return matchedSkills.length;
};

export function talentToCurrentJobMatchScore(user, noSecondaryScore) {
  const userSkills = Array.isArray(parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills')))
    ? parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills'))
    : [];
  const jobSkills = Array.isArray(this.job.skills) ? this.job.skills : [];
  const matchedSkills = userSkills.filter(a => {
    return jobSkills.filter(b => {
      return isMatch(a, b);
    }).length;
  });
  let score = matchedSkills.length;
  if (!noSecondaryScore) {
    score += talentToCurrentJobMatchInterestScore.call(this, user, true) * 0.01;
  }
  return score;
}

export function talentToCurrentJobMatchInterestScore(user, noSecondaryScore) {
  // get user interest preferences
  const userJobTitles = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_TITLES', 'interest'));
  const userJobBusinessAreas = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_BUSINESS_AREA', 'interest'));
  const userJobSeniorities = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_SENIORITY', 'interest'));
  const userJobLocation = parseIfPossible(getUserFieldValue.call(this, user, 'LOCATION', 'interest'));
  const userJobLocationIDs = userJobLocation && Array.isArray(userJobLocation.location) ? userJobLocation.location.map(({ id }) => id) : [];
  // get job details
  const job = this.job || {};
  const { title: jobTitle, location: jobLocation, customFields: jobCustomFields } = job;
  const jobLocationID = jobLocation ? jobLocation.id : null;
  const jobSeniorityObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'seniority') : null;
  const jobBusinessAreaObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'businessArea') : null;
  const jobSeniority = jobSeniorityObj ? jobSeniorityObj.value : null;
  const jobBusinessArea = jobBusinessAreaObj ? jobBusinessAreaObj.value : null;
  let score = 0;
  if (Array.isArray(userJobTitles) && jobTitle && userJobTitles.includes(jobTitle)) {
    score += 1;
  }
  if (Array.isArray(userJobBusinessAreas) && jobBusinessArea && userJobBusinessAreas.includes(jobBusinessArea)) {
    score += 1;
  }
  if (Array.isArray(userJobSeniorities) && jobSeniority && userJobSeniorities.includes(jobSeniority)) {
    score += 0.5;
  }
  if (Array.isArray(userJobLocationIDs) && jobLocation && userJobLocationIDs.includes(jobLocationID)) {
    score += 1;
  }
  if (!noSecondaryScore) {
    score += talentToCurrentJobMatchScore.call(this, user, true) * 0.01;
  }
  // console.log(score);
  return score;
};

export function mentorToCurrentJobMatchScore(mentor, job) {
  const mentorSkills = Array.isArray(parseIfPossible(getUserFieldValue.call(this, mentor, 'JOB_SKILLS', 'mentorship')))
    ? parseIfPossible(getUserFieldValue.call(this, mentor, 'JOB_SKILLS', 'mentorship'))
    : [];
  const jobSkills = Array.isArray(job.skills) ? job.skills : [];
  let skills = jobSkills;
  if (!job.isDevelopment) {
    const userSkills = Array.isArray(parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills')))
      ? parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills'))
      : [];
    skills = skills.reduce((out, el) => {
      if (!userSkills.includes(el)) {
        out.push(el);
      }
      return out;
    }, []);
  }
  const matchedSkills = (Array.isArray(mentorSkills) ? mentorSkills : []).filter(a => {
    return skills.filter(b => {
      return isMatch(a, b);
    }).length;
  });
  return matchedSkills.length;
}

export function currentUserToJobMatchScore(job, noSecondaryScore) {
  const jobSkills = job.skills ? job.skills : [];
  let userSkills = Array.isArray(parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills')))
    ? parseIfPossible(getUserFieldValue.call(this, this.user, 'JOB_SKILLS', 'skills'))
    : [];
  if (job.isDevelopment) {
    const developmentSkills = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_DEVELOPMENT_SKILLS', 'skills'));
    userSkills = [
      ...userSkills,
      ...(Array.isArray(developmentSkills) ? developmentSkills : []),
    ];
  }
  const matchedSkills = jobSkills.filter(a => {
    return userSkills.filter(b => {
      return isMatch(a, b);
    }).length;
  });
  let score = matchedSkills.length;
  if (!noSecondaryScore) {
    score += currentUserToJobMatchInterestScore.call(this, job, true) * 0.01;
  }
  // console.log(score);
  return score;
};

export function currentUserToJobMatchInterestScore(job, noSecondaryScore) {
  // get user interest preferences
  const userJobTitles = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_TITLES', 'interest'));
  const userJobBusinessAreas = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_BUSINESS_AREA', 'interest'));
  const userJobSeniorities = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_SENIORITY', 'interest'));
  const userJobLocation = parseIfPossible(getCurrentUserFieldValue.call(this, 'LOCATION', 'interest'));
  const userJobLocationIDs = userJobLocation && Array.isArray(userJobLocation.location) ? userJobLocation.location.map(({ id }) => id) : [];
  // get job details
  const { title: jobTitle, location: jobLocation, customFields: jobCustomFields } = job;
  const jobLocationID = jobLocation ? jobLocation.id : null;
  const jobSeniorityObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'seniority') : null;
  const jobBusinessAreaObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'businessArea') : null;
  const jobSeniority = jobSeniorityObj ? jobSeniorityObj.value : null;
  const jobBusinessArea = jobBusinessAreaObj ? jobBusinessAreaObj.value : null;
  let score = 0;
  if (Array.isArray(userJobTitles) && jobTitle && userJobTitles.includes(jobTitle)) {
    score += 1;
  }
  if (Array.isArray(userJobBusinessAreas) && jobBusinessArea && userJobBusinessAreas.includes(jobBusinessArea)) {
    score += 1;
  }
  if (Array.isArray(userJobSeniorities) && jobSeniority && userJobSeniorities.includes(jobSeniority)) {
    score += 0.5;
  }
  if (Array.isArray(userJobLocationIDs) && jobLocation && userJobLocationIDs.includes(jobLocationID)) {
    score += 1;
  }
  if (!noSecondaryScore) {
    score += currentUserToJobMatchScore.call(this, job, true) * 0.01;
  }
  // console.log(score);
  return score;
};

export function currentUserToMentorMatchScore(mentor) {
  const mentorSkills = parseIfPossible(getUserFieldValue.call(this, mentor, 'JOB_SKILLS', 'mentorship'));
  const developmentSkills = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_DEVELOPMENT_SKILLS', 'skills'));
  const mentorPreferenceSkills = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_SKILLS', 'mentorpreferences'));
  const developmentSkillsArray = Array.isArray(developmentSkills) ? developmentSkills : [];
  const mentorPreferenceSkillsArray = Array.isArray(mentorPreferenceSkills) ? mentorPreferenceSkills : [];
  const currentUserSkills = [ ...developmentSkillsArray, ...mentorPreferenceSkillsArray ];
  const matchedSkills = (Array.isArray(mentorSkills) ? mentorSkills : [])
    .filter(el => currentUserSkills.includes(el));
  let score = matchedSkills.length;

  // business area
  const mentorBusinessAreasRaw = parseIfPossible(getUserFieldValue.call(this, mentor, 'JOB_BUSINESS_AREA', 'skills'));
  const mentorBusinessAreas = Array.isArray(mentorBusinessAreasRaw) ? mentorBusinessAreasRaw : [];
  const userBusinessAreasRaw = parseIfPossible(getCurrentUserFieldValue.call(this, 'JOB_BUSINESS_AREA', 'mentorpreferences'));
  const userBusinessAreas = Array.isArray(userBusinessAreasRaw) ? userBusinessAreasRaw : [];
  if (mentorBusinessAreas.find(el => userBusinessAreas.includes(el))) {
    score += 0.1;
  }

  // location
  const mentorLocation = parseIfPossible(getUserFieldValue.call(this, mentor, 'LOCATION', 'skills'));
  const userLocation = parseIfPossible(getCurrentUserFieldValue.call(this, 'LOCATION', 'mentorpreferences'));
  const locationObj = mentorLocation && Array.isArray(mentorLocation.location) ? mentorLocation.location[0] : null;
  const userLocationObj = userLocation && Array.isArray(userLocation.location) ? userLocation.location[0] : null;
  if (locationObj && userLocationObj && locationObj.id && locationObj.id === userLocationObj.id) {
    score += 1;
  }
  return score;
};

export function isMatch(a, b) {
  const stemA = stem(a);
  const stemB = stem(b);
  const match = stemA && stemB ? stemA.length > stemB.length ? stemA.includes(stemB) : stemB.includes(stemA) : false;
  return match;
};

export function matchDetails(a, skills) {
  if (!Array.isArray(skills)) return null;
  const stemA = stem(a);
  return skills.reduce((out, b) => {
    const stemB = stem(b);
    const match = stemA && stemB ? stemA.length > stemB.length ? stemA.includes(stemB) : stemB.includes(stemA) : false;
    if (match) {
      const longerWord = stemA.length > stemB.length ? a : b;
      const shorterWord = stemB.length > stemA.length ? a : b;
      return {
        score: stemA === stemB ? 1 : 0.5,
        label: stemA === stemB ? 'Direct match with one of your skills' : `Possible match because '${longerWord}' contains the word '${shorterWord}'`,
      };
    }
    return out;
  }, null);
};

export function talentInterestMatchDetails(user) {
  // get user interest preferences
  const userJobTitles = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_TITLES', 'interest'));
  const userJobBusinessAreas = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_BUSINESS_AREA', 'interest'));
  const userJobSeniorities = parseIfPossible(getUserFieldValue.call(this, user, 'JOB_SENIORITY', 'interest'));
  const userJobLocation = parseIfPossible(getUserFieldValue.call(this, user, 'LOCATION', 'interest'));
  const userJobLocationIDs = userJobLocation && Array.isArray(userJobLocation.location) ? userJobLocation.location.map(({ id }) => id) : [];
  // get job details
  const job = this.job || {};
  const { title: jobTitle, location: jobLocation, customFields: jobCustomFields } = job;
  const jobLocationID = jobLocation ? jobLocation.id : null;
  const jobSeniorityObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'seniority') : null;
  const jobBusinessAreaObj = Array.isArray(jobCustomFields) ? jobCustomFields.find(({ key }) => key === 'businessArea') : null;
  const jobSeniority = jobSeniorityObj ? jobSeniorityObj.value : null;
  const jobBusinessArea = jobBusinessAreaObj ? jobBusinessAreaObj.value : null;
  const interest = {
    jobTitles: (Array.isArray(userJobTitles) ? userJobTitles : []).map(el => ({
      label: el,
      isMatch: jobTitle && typeof jobTitle === 'string' && el && typeof el === 'string' && el.toLowerCase() === jobTitle.toLowerCase(),
    })),
    jobBusinessAreas: (Array.isArray(userJobBusinessAreas) ? userJobBusinessAreas : []).map(el => ({
      label: el,
      isMatch: jobBusinessArea && typeof jobBusinessArea === 'string' && el && typeof el === 'string' && el.toLowerCase() === jobBusinessArea.toLowerCase(),
    })),
    jobSeniorities: (Array.isArray(userJobSeniorities) ? userJobSeniorities : []).map(el => ({
      label: el,
      isMatch: jobSeniority && typeof jobSeniority === 'string' && el && typeof el === 'string' && el.toLowerCase() === jobSeniority.toLowerCase(),
    })),
    jobLocation: (Array.isArray(userJobLocationIDs) ? userJobLocationIDs : []).map(el => ({
      label: userJobLocation.location.find(({ id }) => id === el) ? userJobLocation.location.find(({ id }) => id === el).name : ' - ',
      isMatch: jobLocationID && el === jobLocationID,
    })),
  };
  return interest;
}

export function stem(expr) {
  return expr.trim()
    .split(' ')
    .filter(el => el.length > 2)
    .map(el => stemmer(el))
    .join(' ').trim();
}

export function getUserFieldValue(user, type, group) {
  const { company: { customFields } } = this;
  const { customFields: userCustomFields } = user;
  if (Array.isArray(customFields) && customFields.length && Array.isArray(userCustomFields)) {
    const field = customFields.find(el => el.type === type && el.group === group);
    const fieldKey = field ? field.key : null;
    const userField = fieldKey ? userCustomFields.find(({ key }) => key === fieldKey) : null;
    return userField ? userField.value : null;
  }
  return null;
};

export function getCurrentUserFieldValue(type, group) {
  const { company: { customFields }, user: { customFields: userCustomFields } } = this;
  if (Array.isArray(customFields) && customFields.length && Array.isArray(userCustomFields)) {
    const field = customFields.find(el => el.type === type && el.group === group);
    const fieldKey = field ? field.key : null;
    const userField = fieldKey ? userCustomFields.find(({ key }) => key === fieldKey) : null;
    return userField ? userField.value : null;
  }
  return null;
};

export function parseIfPossible(value) {
  try {
    value = JSON.parse(value);
  } catch (e) {
    // not a json
  }
  return value;
};



// WEBPACK FOOTER //
// ./src/lib/imMatching.js